import { useSetAtom } from 'jotai';
import { shogunComposerDraftAtom } from '../../stores/shogun/atoms';

/**
 * Clickable first moves for a view whose only editing affordance is the docked
 * agent (app-shell ADR-013). Clicking one FILLS the composer; it
 * never sends — the user still reads and edits what they are about to ask.
 */
export function WorkStarterPrompts({ prompts }: { prompts: string[] }) {
  const setDraft = useSetAtom(shogunComposerDraftAtom);

  return (
    <div className="flex flex-col items-stretch gap-2" data-testid="agent-starter-prompts">
      {prompts.map((prompt) => (
        <button
          key={prompt}
          type="button"
          data-testid="agent-starter-prompt"
          onClick={() => setDraft(prompt)}
          className="rounded-md bg-secondary px-3 py-2 text-left text-body text-secondary-foreground transition-colors hover:bg-secondary/80"
        >
          {prompt}
        </button>
      ))}
    </div>
  );
}
